import { systemtheme, systemthemeDark } from "orcs-design-system";
import { useState, useCallback } from "react";

import { getActiveTheme, saveActiveTheme } from "src/services/localStorage";

const THEME_LIGHT = "light";
const THEME_DARK = "dark";

const resolveTheme = (value) =>
  value === THEME_DARK ? THEME_DARK : THEME_LIGHT;

const useThemeSwitching = () => {
  const initialIsDark = resolveTheme(getActiveTheme()) === THEME_DARK;

  const [theme, setTheme] = useState(
    initialIsDark ? systemthemeDark : systemtheme
  );
  const [isDarkTheme, setIsDarkTheme] = useState(initialIsDark);

  const themeSwitcher = useCallback((switchToDark) => {
    const isDark = Boolean(switchToDark);
    setTheme(isDark ? systemthemeDark : systemtheme);
    setIsDarkTheme(isDark);
    saveActiveTheme(isDark ? THEME_DARK : THEME_LIGHT);
  }, []);

  return { themeSwitcher, theme, isDarkTheme };
};

export default useThemeSwitching;
